import { render } from "./ServicesDatatableFormCard.vue?vue&type=template&id=3d91e721"
import script from "./ServicesDatatableFormCard.vue?vue&type=script&lang=js"
export * from "./ServicesDatatableFormCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__